import { AnimatePresence, motion } from "motion/react";
import { useMemo } from "react";

import styled from "styled-components/macro";
import theme from "theme";

import FnrIcon from "UI/FnrIcon";
import FnrTypography from "UI/FnrTypography";

import {
  useDebouncedSearchValue,
  useSearchValue,
  useSignupsToDisplay,
} from "./signupsAndEventsStore";

export default function NoSearchMatches() {
  const searchValue = useSearchValue();
  const debouncedSearchValue = useDebouncedSearchValue();
  const signupsToDisplay = useSignupsToDisplay();

  /** @type {boolean} */
  const shouldShow = useMemo(
    () => searchValue.length > 0 && signupsToDisplay.length === 0,
    [searchValue.length, signupsToDisplay.length]
  );

  return (
    <AnimatePresence>
      {shouldShow && (
        <Wrapper
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          // exit animation intentionally omitted
          transition={{ duration: 0.1 }}
        >
          <IconWrapper>
            <FnrIcon far fa-clipboard shadow />
          </IconWrapper>
          <FnrTypography color="textLight" shadow italic>
            No signups matched{" "}
            <SearchValueWrapper>{debouncedSearchValue}</SearchValueWrapper>
          </FnrTypography>
        </Wrapper>
      )}
    </AnimatePresence>
  );
}

const Wrapper = styled(motion.div)`
  text-align: center;
`;

const IconWrapper = styled.div`
  font-size: 1.75rem;
  color: ${theme.colors.textLight};
  // hand-adjusted to be vertically centered
  padding-top: 1.25rem;
`;

const SearchValueWrapper = styled.span`
  font-style: normal;
  font-weight: bold;
`;
